import {
  AI_AUTOPILOT_USER_ID,
  CHATBOT_USER_ID,
} from "@redotech/ai-autopilot-constants/constant";
import { MongoUserId } from "@redotech/effect-api-shared/ids/mongo-ids";
import AiStarIcon from "@redotech/redo-icons/ai-star.svg";
import { getUserAvatarUrl } from "@redotech/redo-merchant-app-common/get-avatar-url";
import { GetUser as User } from "@redotech/redo-model/user";
import type {
  RedoListItem,
  TextRedoListItem,
} from "@redotech/redo-web/arbiter-components/list/redo-list";
import ChatBotIcon from "@redotech/redo-web/icon-old/chat-bot.svg";
import { ObjectId } from "bson";

export function getUserDisplayName(user: User): string {
  if (user._id === CHATBOT_USER_ID) {
    return "Chatbot";
  }
  if (user._id === AI_AUTOPILOT_USER_ID) {
    return "AI Autopilot";
  }
  return user.name;
}

export function getUserLeadingItem(
  user: User,
  displayName: string,
): TextRedoListItem<User>["leadingItem"] {
  if (user._id === CHATBOT_USER_ID) {
    return { type: "icon", Icon: ChatBotIcon };
  }
  if (user._id === AI_AUTOPILOT_USER_ID) {
    return { type: "icon", Icon: AiStarIcon };
  }
  return {
    type: "avatar",
    alt: "User profile picture",
    imageUrl: getUserAvatarUrl({ email: user.email }),
    name: displayName,
  };
}

export function buildAssigneeListItems(
  users: User[],
): RedoListItem<User | null>[] {
  const userItems: RedoListItem<User>[] = users.map((user) => {
    const name = getUserDisplayName(user);
    return {
      type: "text",
      id: MongoUserId.fromObjectId(new ObjectId(user._id)),
      text: name,
      value: user,
      leadingItem: getUserLeadingItem(user, name),
    };
  });

  const unassigned: RedoListItem<null> = {
    type: "text",
    id: "unassigned",
    text: "Unassigned",
    value: null,
  };

  return [unassigned, ...userItems];
}
